var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Configurar Firma Simple EDigital")]),
    _vm.existeEdigital
      ? _c("div", { staticClass: "alert alert-success mb-3" }, [
          _vm._v(
            " Se ha encontrado su certificado activo en EDigital. Ingrese la información faltante y la contraseña que usa normalmente en EDigital. "
          )
        ])
      : _c("div", { staticClass: "alert alert-warning mb-3" }, [
          _vm._v(
            " Debe registrar sus nombres y apellidos tal como salen registrados en su cédula de identidad. De lo contrario su firma puede ser invalidada y revocada. "
          )
        ]),
    _c(
      "form",
      {
        attrs: { autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.save($event)
          }
        }
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "cedulaNombre" } }, [
                _vm._v("Nombres *")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.cedulaNombre,
                    expression: "formData.cedulaNombre"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "cedulaNombre",
                  name: "cedulaNombre",
                  maxlength: "50",
                  disabled: _vm.existeEdigital
                },
                domProps: { value: _vm.formData.cedulaNombre },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.formData, "cedulaNombre", $event.target.value)
                  }
                }
              }),
              _vm.errors.has("cedulaNombre")
                ? _c("small", { staticClass: "form-text text-danger" }, [
                    _vm._v(" " + _vm._s(_vm.errors.first("cedulaNombre")) + " ")
                  ])
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "cedulaApellidos" } }, [
                _vm._v("Apellidos *")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.cedulaApellidos,
                    expression: "formData.cedulaApellidos"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "cedulaApellidos",
                  name: "cedulaApellidos",
                  maxlength: "50",
                  disabled: _vm.existeEdigital
                },
                domProps: { value: _vm.formData.cedulaApellidos },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.formData,
                      "cedulaApellidos",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm.errors.has("cedulaApellidos")
                ? _c("small", { staticClass: "form-text text-danger" }, [
                    _vm._v(
                      " " + _vm._s(_vm.errors.first("cedulaApellidos")) + " "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "cedulaFnacimiento" } }, [
                _vm._v("Fecha de nacimiento *")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.cedulaFnacimiento,
                    expression: "formData.cedulaFnacimiento"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "date",
                  id: "cedulaFnacimiento",
                  name: "cedulaFnacimiento"
                },
                domProps: { value: _vm.formData.cedulaFnacimiento },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.formData,
                      "cedulaFnacimiento",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm.errors.has("cedulaFnacimiento")
                ? _c("small", { staticClass: "form-text text-danger" }, [
                    _vm._v(
                      " " + _vm._s(_vm.errors.first("cedulaFnacimiento")) + " "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "cedulaGender" } }, [
                _vm._v("Género *")
              ]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.cedulaGender,
                      expression: "formData.cedulaGender"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "cedulaGender",
                    name: "cedulaGender",
                    disabled: _vm.existeEdigital
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formData,
                        "cedulaGender",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "", disabled: "" } }, [
                    _vm._v("Seleccione género")
                  ]),
                  _vm._l(_vm.genderOptions, function(option) {
                    return _c(
                      "option",
                      { key: option.id, domProps: { value: option.id } },
                      [_vm._v(" " + _vm._s(option.nombre) + " ")]
                    )
                  })
                ],
                2
              ),
              _vm.errors.has("cedulaGender")
                ? _c("small", { staticClass: "form-text text-danger" }, [
                    _vm._v(" " + _vm._s(_vm.errors.first("cedulaGender")) + " ")
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "correoPersonal" } }, [
                _vm._v("Correo personal *")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.correoPersonal,
                    expression: "formData.correoPersonal"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "email",
                  id: "correoPersonal",
                  name: "correoPersonal",
                  disabled: _vm.existeEdigital
                },
                domProps: { value: _vm.formData.correoPersonal },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.formData,
                      "correoPersonal",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm.errors.has("correoPersonal")
                ? _c("small", { staticClass: "form-text text-danger" }, [
                    _vm._v(
                      " " + _vm._s(_vm.errors.first("correoPersonal")) + " "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "typeIdentityDocument" } }, [
                _vm._v("Tipo de documento *")
              ]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.typeIdentityDocument,
                      expression: "formData.typeIdentityDocument"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "typeIdentityDocument",
                    name: "typeIdentityDocument",
                    disabled: _vm.existeEdigital || _vm.hasExistingId
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formData,
                        "typeIdentityDocument",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "", disabled: "" } }, [
                    _vm._v("Seleccione tipo documento")
                  ]),
                  _vm._l(_vm.documentTypes, function(option) {
                    return _c(
                      "option",
                      { key: option.id, domProps: { value: option.id } },
                      [_vm._v(" " + _vm._s(option.nombre) + " ")]
                    )
                  })
                ],
                2
              ),
              _vm.errors.has("typeIdentityDocument")
                ? _c("small", { staticClass: "form-text text-danger" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.errors.first("typeIdentityDocument")) +
                        " "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "identityDocument" } }, [
                _vm._v("Número de serie *")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.identityDocument,
                    expression: "formData.identityDocument"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "identityDocument",
                  name: "identityDocument",
                  maxlength: "25",
                  disabled: _vm.existeEdigital || _vm.hasExistingId
                },
                domProps: { value: _vm.formData.identityDocument },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.formData,
                      "identityDocument",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm.errors.has("identityDocument")
                ? _c("small", { staticClass: "form-text text-danger" }, [
                    _vm._v(
                      " " + _vm._s(_vm.errors.first("identityDocument")) + " "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "hash" } }, [
                _vm._v("Contraseña del certificado *")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.hash,
                    expression: "formData.hash"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|min:6",
                    expression: "'required|min:6'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "password",
                  id: "hash",
                  name: "hash",
                  autocomplete: "new-password"
                },
                domProps: { value: _vm.formData.hash },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.formData, "hash", $event.target.value)
                  }
                }
              }),
              _vm.existeEdigital
                ? _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v(" Ingrese la misma contraseña que usa en EDigital. ")
                  ])
                : _vm._e(),
              _vm.errors.has("hash")
                ? _c("small", { staticClass: "form-text text-danger" }, [
                    _vm._v(" " + _vm._s(_vm.errors.first("hash")) + " ")
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("Fotografía frontal de cédula *")]),
                _vm.anteriorPreview
                  ? _c("div", { staticClass: "mb-2" }, [
                      _c("img", {
                        staticClass: "img-thumbnail",
                        staticStyle: {
                          "max-width": "200px",
                          "max-height": "150px"
                        },
                        attrs: { src: _vm.anteriorPreview, alt: "Frontal" }
                      })
                    ])
                  : _vm._e(),
                _c("input", {
                  ref: "inputAnterior",
                  staticClass: "form-control-file",
                  attrs: { type: "file", accept: "image/*" },
                  on: { change: _vm.handleAnteriorUpload }
                }),
                _vm.uploadingAnterior
                  ? _c("b-progress", {
                      staticClass: "mt-1",
                      attrs: {
                        value: _vm.progressAnterior,
                        max: 100,
                        variant: "warning"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("Fotografía trasera de cédula *")]),
                _vm.posteriorPreview
                  ? _c("div", { staticClass: "mb-2" }, [
                      _c("img", {
                        staticClass: "img-thumbnail",
                        staticStyle: {
                          "max-width": "200px",
                          "max-height": "150px"
                        },
                        attrs: { src: _vm.posteriorPreview, alt: "Posterior" }
                      })
                    ])
                  : _vm._e(),
                _c("input", {
                  ref: "inputPosterior",
                  staticClass: "form-control-file",
                  attrs: { type: "file", accept: "image/*" },
                  on: { change: _vm.handlePosteriorUpload }
                }),
                _vm.uploadingPosterior
                  ? _c("b-progress", {
                      staticClass: "mt-1",
                      attrs: {
                        value: _vm.progressPosterior,
                        max: 100,
                        variant: "warning"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _vm.hasExistingId
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "custom-control custom-checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.activa,
                          expression: "formData.activa"
                        }
                      ],
                      staticClass: "custom-control-input",
                      attrs: { type: "checkbox", id: "activaCheck" },
                      domProps: {
                        checked: Array.isArray(_vm.formData.activa)
                          ? _vm._i(_vm.formData.activa, null) > -1
                          : _vm.formData.activa
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.formData.activa,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.formData,
                                  "activa",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.formData,
                                  "activa",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.formData, "activa", $$c)
                          }
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "custom-control-label",
                        attrs: { for: "activaCheck" }
                      },
                      [_vm._v(" Firma activa ")]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _c("div", { staticClass: "row mt-3 justify-content-end" }, [
          _c("div", { staticClass: "col-md-4 text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "submit", disabled: _vm.saving }
              },
              [
                _vm.saving
                  ? _c("b-spinner", { attrs: { small: "", variant: "light" } })
                  : _c("span", [_vm._v("Guardar configuración")])
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }